import { render, staticRenderFns } from "./addsend.vue?vue&type=template&id=555d3934&scoped=true&"
import script from "./addsend.vue?vue&type=script&lang=js&"
export * from "./addsend.vue?vue&type=script&lang=js&"
import style0 from "./addsend.vue?vue&type=style&index=0&id=555d3934&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555d3934",
  null
  
)

export default component.exports